import { EGlobalConfig } from '@/enums/cacheEnum'
import { useStorage } from '@/hooks/system/useStorage'
import { useConfigStoreWithOut } from '@/store/modules/config'
import type { IThemeText } from '@/types/globalConfig'

/**
 * url优先
 * token apiSrc pushSrc themeText 已默认优先读取 url
*/
const urlKey = ['platformName', 'nickname', 'currencyId', 'cbs', 'tutorialPop', 'hideBigData', 'handicap', 'enableSportFilter', 'jumpUseIframe', 'language', 'color']
export function initConfig(url?: string) {
  const useConfig = useConfigStoreWithOut()

  const tokenKey = EGlobalConfig.token
  const apiSrcKey = EGlobalConfig.apiSrc
  const pushSrcKey = EGlobalConfig.pushSrc
  const noTypeKey = EGlobalConfig.noType

  const globalConfigKey = Object.keys(EGlobalConfig)

  let urlString = url || window.location.href
  let themeText: IThemeText = null
  const reg = /themeText=\{(.*?)\}/
  if (!useConfig.themeText || reg.test(urlString)) {
    // themeText 特殊处理
    const themeTextMatch = urlString.match(reg)
    const themeTextStr = themeTextMatch && themeTextMatch[1] ? decodeURIComponent(`{${themeTextMatch[1]}}`).replace(/=&/g, '&').replace(/&quot;/g, '"') : null

    try {
      themeText = JSON.parse(themeTextStr)
      useConfig.setConfig('themeText', themeText)
    } catch (err) {
      themeText = null
    }
    urlString = urlString.replace(reg, '')
  } else {
    themeText = useConfig.themeText
  }

  const urlParams = new URLSearchParams(urlString.split('?')[1])

  // url 上的三兄弟
  const token = urlParams.get(tokenKey)
  const apiSrc = urlParams.get(apiSrcKey)
  const pushSrc = urlParams.get(pushSrcKey)
  const noType = urlParams.get(noTypeKey)

  // todo 单独存一个缓存
  useStorage.ls.set('noType', noType)

  const pcAddress = location.origin

  // 查看config数据

  async function getConfig(isLogin?: boolean) {
    // 这三个参数 url如果都存在，则覆盖本地
    // 其他参数以本地缓存优先
    if (token) {
      useConfig.setConfig(tokenKey, token)
      if (apiSrc) useConfig.setConfig(apiSrcKey, apiSrc)
      if (pushSrc) useConfig.setConfig(pushSrcKey, pushSrc)
      if (pcAddress) {
        useStorage.ls.set('URL_PARAMS', location.href.split('?')[1])
        useStorage.ls.set('pcAddress', pcAddress)
      }

      useStorage.ls.set('jumpUseIframe', urlParams.get('jumpUseIframe'))
    } else {
    // 已处理url参数
    // console.log('[已处理url参数]')
      return null
    }

    // // urlKey 有更新 就覆盖本地数据，其余都优先读取本地
    // if (noType === '2') {
    //   urlKey.push('language')
    // }
    urlKey.forEach((e) => {
      const urlValue = urlParams.get(e)
      if (urlValue) useConfig.setConfig(e, urlValue)
    })

    if (isLogin && ((token && token === useStorage.ls.get(tokenKey)) || !token)) {
      return clearUrlParams(urlParams, globalConfigKey)
    }

    // 初次登录 把url上的所有参数存至本地
    urlParams.forEach((value, key) => {
      if (globalConfigKey.includes(key)) useConfig.setConfig(key, value)
    })

    return clearUrlParams(urlParams, globalConfigKey)
  }

  /** 清除地址栏参数 */
  function clearUrlParams(urlParams: URLSearchParams, globalConfigKey: string[]) {
    return new Promise((resolve) => {
      globalConfigKey.forEach((key: string) => {
        urlParams.delete(key)
      })
      resolve(Object.fromEntries(urlParams.entries()))
    })
  }

  return {
    getConfig,
    themeText,
    urlParams,
  }
}
